// extracted by mini-css-extract-plugin
export default {"modalOverlay":"PopupWrapper_modalOverlay__5FXGg","modalContent":"PopupWrapper_modalContent__LsXZA","closeIcon":"PopupWrapper_closeIcon__2Tfml"};